import { Color, HorizontalFlex, InputChip, SearchTrigger } from "@enxcs/dap-ui-stratos";
import styled from "styled-components";

export const SearchContainer = styled(HorizontalFlex)`
  max-width: 347px;
  width: 100%;
`;

export const StyledSearchTrigger = styled(SearchTrigger)`
  box-sizing: border-box;
  input {
    border: 1px solid ${Color.Neutral.V40} !important;
  }
`;

export const ActiveInputChip = styled(InputChip)`
  background-color: ${Color.Blue.V30};
`;
